import { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { useThemeMode } from '_metronic/partials'
import { formatGrandNumber } from 'Utils/numberFormat'

interface IssueSummaryChartProps {
  categories: string[]
  data: number[]
  colors: string[]
}

const IssueSummaryChart: React.FC<IssueSummaryChartProps> = ({ categories, data, colors }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(chartRef.current, getChartOptions(categories, data, colors, mode))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, categories, data, colors])

  return (
    <>
      <div
        ref={chartRef}
        id='kt_charts_issue_summary_chart'
        style={{ height: '400px' }}
        className='card-rounded-bottom'></div>
    </>
  )
}

function getChartOptions(
  categories: string[],
  data: number[],
  colors: string[],
  mode: string
): ApexOptions {
  const textColor = mode === 'dark' ? '#A1A5B7' : '#7E8299'

  return {
    series: [
      {
        name: 'จำนวนครั้ง',
        data: data,
      },
    ],
    colors: colors,
    chart: {
      type: 'bar',
      height: 400,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: '100%',
        borderRadius: 8,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ['#000000'],
        fontSize: '12px',
        fontWeight: 'light',
      },
      formatter: function (val: number | string): string | number {
        return typeof val === 'number' ? formatGrandNumber(val) : val
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          colors: textColor,
        },
      },
    },
    yaxis: {
      title: {
        text: 'ประเภทปัญหา',
        style: {
          color: textColor,
        },
      },
      labels: {
        style: {
          colors: textColor,
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return formatGrandNumber(val) + ' ครั้ง'
        },
      },
    },
  }
}

export default IssueSummaryChart
